import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsV1GetsafeDe } from '@flows/insurance/schemas'

const contents_natural_disasters = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('natural_disasters_coverage')]:
        BaseSchema_ContentsV1GetsafeDe.shape.natural_disasters_coverage,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_natural_disasters.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('natural_disasters_coverage'),
      },
      {
        type: 'infoBox',
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey:
                'sharedFlows_contentsNxt:steps.contents_natural_disasters.infoBox.text',
            },
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey:
                'sharedFlows_contentsNxt:steps.contents_natural_disasters.infoBox.text2',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'contents_location',
  }) as const satisfies AnyStepConfiguration

export default contents_natural_disasters
